import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzCardComponent, SzNumFocalComponent, SzTileComponent } from '@ui';
import { SessionBestFocal, SessionBestTile } from './session-best-block.types';

@Component({
  selector: 'lib-session-best-block',
  templateUrl: './session-best-block.component.html',
  styleUrls: ['./session-best-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzCardComponent, SzNumFocalComponent, SzTileComponent]
})
export class SessionBestBlockComponent {
  readonly focal: InputSignal<SessionBestFocal | null> = input<SessionBestFocal | null>(null);
  readonly tiles: InputSignal<readonly SessionBestTile[]> = input<readonly SessionBestTile[]>([]);
}
